module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "recommendfriend"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticClass: "page_single layout_fullwidth_padding"
  }, [_c('ReferralMainComponent', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "customization": _vm.customization,
      "sharedLinkData": _vm.sharedLinkData,
      "loading": _vm.loading
    },
    on: {
      "share": function($event) {
        return _vm.onShare($event)
      },
      "next": function($event) {
        return _vm.onNext($event)
      }
    }
  })], 1), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bcd2cbea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcd2cbea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/referral-program/recommend-friend.vue
// module id = 810
// module chunks = 0